export default {
  isLogin: function () {
    return !!window.sessionStorage.getItem('accessToken')
  },
  save: function (userinfo, uiLang, newHome = false) {
    // alert(userinfo)
    // alert(userinfo.result.tokens)
   // userinfo && userinfo.username && window.sessionStorage.setItem('username', userinfo.username)
   // accessToken && window.sessionStorage.setItem('accessToken', accessToken)
   // uuid && window.sessionStorage.setItem('uuid', uuid)
    sessionStorage.setItem('accessToken', userinfo.accessToken)
    sessionStorage.setItem('uiLang', uiLang)
    this.saveNewHome(newHome)
   // window.sessionStorage.setItem('userId', '10001')
   // window.sessionStorage.setItem('supplierId', '12345')
   // window.sessionStorage.setItem('distributorId', '54321')
  },
  saveNewHome: function (newHome) {
    sessionStorage.setItem('newHome', newHome)
  },
  getAccessToken: function () {
    return window.sessionStorage.getItem('accessToken')
  },
  getUiLang: function () {
    return window.sessionStorage.getItem('uiLang')
  },
  loadUserInfo: function () {
    let accessToken = window.sessionStorage.getItem('accessToken')
    if (accessToken) {
      // 登入
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/user.js